import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from './paths';
import HomePage from '../components/pages/HomePage';
import GalleryPage from '../components/pages/clinic/GalleryPage';
import LocationPage from '../components/pages/clinic/LocationPage';
import ArbitrationPage from '../components/pages/clinic/ArbitrationPage';
import ContactPage from '../components/pages/ContactPage';
import AboutUsPage from '../components/pages/clinic/AboutUsPage';
import TermosPage from '../components/pages/clinic/TermosPage';
import PrivacyPage from '../components/pages/clinic/PrivacyPage';
import CookiesPage from '../components/pages/clinic/CookiesPage';

const Router: React.FC = () => {
    return (
        <Routes>
            <Route path={ROUTES.HOME} element={<HomePage />} />
            
            {/* Clinic Routes */}
            <Route path={ROUTES.ABOUT_US} element={<AboutUsPage />} />
            <Route path={ROUTES.GALLERY} element={<GalleryPage />} />
            <Route path={ROUTES.LOCATION} element={<LocationPage />} />
            <Route path={ROUTES.ARBITRATION} element={<ArbitrationPage />} />
            <Route path={ROUTES.TERMOS} element={<TermosPage />} />
            <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />
            <Route path={ROUTES.COOKIES} element={<CookiesPage />} />
            <Route path={ROUTES.CONTACT} element={<ContactPage />} />
            
            {/* Service Routes - redirect to home (integrative approach) */}
            <Route path="/services/*" element={<Navigate to={ROUTES.HOME} replace />} />

            {/* Fallback Route */}
            <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
    );
};

export default Router;
